module.exports = __webpack_public_path__ + "media/default-events.f80e8d30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/default-events.svg
// module id = 578
// module chunks = 57